
import './App.css';
import Home from "./Pages/home"
import Navbar from "./Section/Header/navbar"
import Footer from "./Section/Footer/footer"
import Terms from "./Section/TnC/TnC.jsx"
import Privacy from "./Section/privacy/Privacy"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/termsandcondition" element={<Terms />}/>
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
